// Equipment profiles, branch equipment and the desk's profile switcher
// (admin/equipment/*). Native review pending (az, ru).
import type { Phrase } from '../staffText'

export const equipment = {
  // tab
  'eq.tab.profiles': { en: 'Equipment profiles', az: 'Avadanlıq profilləri', ru: 'Профили оборудования' },
  'eq.tab.add': { en: 'Add profile', az: 'Profil əlavə et', ru: 'Добавить профиль' },
  'eq.tab.duplicate': { en: 'Duplicate', az: '', ru: '' },
  'eq.tab.unit.add': { en: 'Add', az: 'Əlavə et', ru: 'Добавить' },
  'eq.kind.service_point': { en: 'Counters', az: 'Xidmət nöqtələri', ru: 'Точки обслуживания' },
  'eq.kind.kiosk': { en: 'Kiosks', az: 'Kiosklar', ru: 'Киоски' },
  'eq.kind.display': { en: 'Main displays', az: 'Zal ekranları', ru: 'Табло' },
  'eq.kind.desk_display': { en: 'Counter displays', az: 'Pəncərə ekranları', ru: 'Табло окон' },
  'eq.kind.feedback': { en: 'Feedback tablets', az: 'Rəy planşetləri', ru: 'Планшеты отзывов' },
  'eq.kind.one.service_point': { en: 'Counter', az: 'Xidmət nöqtəsi', ru: 'Точка обслуживания' },
  'eq.kind.one.kiosk': { en: 'Kiosk', az: 'Kiosk', ru: 'Киоск' },
  'eq.kind.one.display': { en: 'Main display', az: 'Zal ekranı', ru: 'Табло' },
  'eq.kind.one.desk_display': { en: 'Counter display', az: 'Pəncərə ekranı', ru: 'Табло окна' },
  'eq.kind.one.feedback': { en: 'Feedback tablet', az: 'Rəy planşeti', ru: 'Планшет отзывов' },
  'eq.tab.count': { en: 'Starting count', az: 'Standart say', ru: 'Количество по умолчанию' },
  'eq.tab.noneOfKind': { en: 'None. Branches on this profile get none.', az: '', ru: '' },
  'eq.tab.inUse': { en: 'On {n} branch|On {n} branches', az: '{n} filialda', ru: 'В {n} отделении|В {n} отделениях|В {n} отделениях' },
  'eq.tab.onlyOne': { en: 'The only profile', az: 'Yeganə profil', ru: 'Единственный профиль' },
  'eq.tab.stale': { en: 'Saved by someone else', az: 'Başqası yadda saxlayıb', ru: 'Сохранено другим пользователем' },
  'eq.tab.reload': { en: 'Reload', az: 'Yenidən yüklə', ru: 'Обновить' },
  'eq.tab.discard': { en: 'Discard changes?', az: 'Dəyişikliklər silinsin?', ru: 'Отменить изменения?' },
  'eq.tab.saved': { en: 'Saved', az: 'Yadda saxlanıldı', ru: 'Сохранено' },
  'eq.tab.description': { en: 'Description', az: 'Təsvir', ru: 'Описание' },
  'eq.tab.deleteAsk': { en: 'Delete profile?', az: 'Profil silinsin?', ru: 'Удалить профиль?' },
  'eq.tab.done': { en: 'Done', az: 'Hazır', ru: 'Готово' },

  // sheet
  'eq.sheet.useOwn': { en: 'Use own value', az: 'Öz dəyəri', ru: 'Своё значение' },
  'eq.src.default': { en: 'Built-in', az: 'Daxili', ru: 'Встроенное' },
  'eq.src.profile': { en: 'Profile', az: 'Profil', ru: 'Профиль' },
  'eq.src.own': { en: 'Own', az: 'Öz', ru: 'Своё' },
  'eq.sheet.design': { en: 'Design', az: 'Dizayn', ru: 'Макет' },
  'eq.sheet.ticket': { en: 'Ticket', az: 'Talon', ru: 'Талон' },
  'eq.sheet.default': { en: 'Default', az: 'Standart', ru: 'По умолчанию' },
  'eq.sheet.gone': { en: 'Not available', az: 'Mövcud deyil', ru: 'Недоступен' },
  'eq.sheet.switches': { en: 'Counter buttons', az: 'Pəncərə düymələri', ru: 'Кнопки окна' },
  'eq.sheet.removeAsk': { en: 'Branches lose these on save', az: 'Dərc edəndə filiallar bunları itirəcək', ru: 'Отделения потеряют их при публикации' },
  'eq.sheet.nameTaken': { en: 'Name already used', az: 'Bu ad artıq var', ru: 'Название уже занято' },
  'eq.sheet.printer': { en: 'Printer', az: 'Printer', ru: 'Принтер' },
  'eq.sheet.paper': { en: 'Paper', az: 'Kağız', ru: 'Бумага' },
  'eq.sheet.mm': { en: '{n} mm', az: '{n} mm', ru: '{n} мм' },
  'eq.sheet.copies': { en: 'Copies', az: 'Nüsxə', ru: 'Копии' },
  'eq.sheet.cut': { en: 'Cut the paper', az: 'Kağızı kəs', ru: 'Обрезать бумагу' },
  'eq.sheet.picture': { en: 'Print as a picture', az: 'Şəkil kimi çap et', ru: 'Печатать картинкой' },
  'eq.sheet.pictureHint': { en: 'Needed for Azerbaijani letters like ə.', az: 'ə kimi Azərbaycan hərfləri üçün lazımdır.', ru: 'Нужно для азербайджанских букв вроде ə.' },
  'eq.sheet.plain': { en: 'Print as plain text', az: 'Sadə mətn kimi çap et', ru: 'Печатать текстом' },
  'eq.sheet.plainHint': { en: 'Accents are lost.', az: 'Xüsusi hərflər itir.', ru: 'Особые буквы теряются.' },
  'eq.sheet.sound': { en: 'Sound', az: 'Səs', ru: 'Звук' },
  'eq.sheet.soundOn': { en: 'Sound on', az: 'Səs açıqdır', ru: 'Звук включён' },
  'eq.sheet.readCalls': { en: 'Read calls out', az: 'Çağırışları səsləndir', ru: 'Зачитывать вызовы' },
  'eq.sheet.language': { en: 'Language', az: 'Dil', ru: 'Язык' },
  'eq.sheet.idleLanguage': { en: 'Idle language', az: 'Gözləmə rejimində dil', ru: 'Язык в режиме ожидания' },
  'eq.sheet.said': { en: 'Said', az: 'Neçə dəfə', ru: 'Сколько раз' },
  'eq.sheet.once': { en: 'Once', az: 'Bir dəfə', ru: 'Один раз' },
  'eq.sheet.twice': { en: 'Twice', az: 'İki dəfə', ru: 'Дважды' },
  'eq.sheet.threeTimes': { en: 'Three times', az: 'Üç dəfə', ru: 'Три раза' },
  'eq.sheet.tone': { en: 'Chime', az: 'Siqnal', ru: 'Сигнал' },
  'eq.sheet.chimeSound': { en: 'Chime sound', az: '', ru: '' },
  'eq.sheet.builtIn': { en: 'Built-in', az: '', ru: '' },
  'eq.sheet.uploadSound': { en: 'Upload', az: '', ru: '' },
  'eq.sheet.play': { en: 'Play', az: '', ru: '' },
  'eq.sheet.soundTooLong': { en: 'Sound over {n} seconds.', az: '', ru: '' },
  'eq.sheet.fullScreen': { en: 'Full-screen calls', az: 'Tam ekran çağırışlar', ru: 'Вызов на весь экран' },
  'eq.sheet.on': { en: 'On', az: 'Aktiv', ru: 'Включено' },

  // branch
  'eq.branch.operation': { en: 'Operation profile', az: 'Əməliyyat profili', ru: 'Операционный профиль' },
  'eq.branch.equipment': { en: 'Equipment profile', az: 'Avadanlıq profili', ru: 'Профиль оборудования' },
  'eq.branch.carry': { en: 'Keeps {kept}, adds {created}', az: 'Qalır: {kept}, əlavə olunur: {created}', ru: 'Остаётся: {kept}, добавится: {created}' },
  'eq.branch.carryDrops': { en: 'Removes {codes}', az: 'Silinir: {codes}', ru: 'Удаляются: {codes}' },
  'eq.branch.carryDesigns': {
    en: 'Clears {n} kiosk design|Clears {n} kiosk designs',
    az: 'Kiosk dizaynı sıfırlanır: {n}',
    ru: 'Сбрасываются макеты киосков: {n}',
  },
  'eq.branch.carryNotMade': {
    en: '{unit}: {count} not added, no counter to link',
    az: '{unit}: {count} əlavə olunmur, bağlanacaq pəncərə yoxdur',
    ru: '{unit}: {count} не добавится, нет окна для привязки',
  },
  'eq.branch.didDrop': { en: 'Removed {codes}', az: 'Silindi: {codes}', ru: 'Удалены: {codes}' },
  'eq.branch.didDesigns': {
    en: 'Cleared {n} kiosk design|Cleared {n} kiosk designs',
    az: 'Kiosk dizaynı sıfırlandı: {n}',
    ru: 'Сброшены макеты киосков: {n}',
  },
  'eq.branch.didNotMake': {
    en: '{unit}: {count} not added, no counter to link',
    az: '{unit}: {count} əlavə olunmadı, bağlanacaq pəncərə yoxdur',
    ru: '{unit}: {count} не добавлено, нет окна для привязки',
  },
  'eq.branch.apply': { en: 'Apply', az: 'Tətbiq et', ru: 'Применить' },
  'eq.branch.bringBackAsk': { en: 'Put version {v} back on the floor?', az: '{v} versiyası zala qaytarılsın?', ru: 'Вернуть версию {v} в зал?' },
  'eq.branch.bringBackDone': { en: 'Version {v} live', az: 'Versiya {v} aktivdir', ru: 'Версия {v} в работе' },
  'eq.branch.versionOf': { en: '{op} r{n}, {eq} r{m}', az: '{op} r{n}, {eq} r{m}', ru: '{op} r{n}, {eq} r{m}' },
  'eq.branch.overwrote': { en: 'Saved over {who}’s changes', az: 'Üzərinə yazıldı: {who}', ru: 'Перезаписаны изменения: {who}' },
  'eq.branch.notSaved': { en: 'Not saved', az: 'Yadda saxlanmayıb', ru: 'Не сохранено' },
  'eq.branch.unsaved': { en: 'Unsaved changes', az: 'Saxlanmamış dəyişikliklər', ru: 'Несохранённые изменения' },
  'eq.branch.leaveAsk': { en: 'Leave without saving?', az: 'Saxlamadan çıxılsın?', ru: 'Выйти без сохранения?' },

  // instances
  'eq.key.title': { en: 'Machine key', az: '', ru: '' },
  'eq.key.new': { en: 'New key', az: '', ru: '' },
  'eq.key.stopsOld': { en: 'A new key stops the old one at once.', az: '', ru: '' },
  'eq.key.issued': { en: 'Key from {when}', az: '', ru: '' },
  'eq.key.has': { en: 'Has a key', az: '', ru: '' },
  'eq.key.none': { en: 'No key', az: '', ru: '' },
  'eq.key.needed': { en: 'Needs a key', az: '', ru: '' },
  'eq.key.once': { en: 'Shown once. Open it on the machine.', az: '', ru: '' },
  'eq.inst.none': { en: 'No equipment.', az: '', ru: '' },
  'eq.inst.addToProfile': { en: 'Add to profile', az: '', ru: '' },
  'eq.inst.toProfile': { en: 'Profile', az: '', ru: '' },
  'eq.inst.title': { en: 'Equipment', az: 'Avadanlıq', ru: 'Оборудование' },
  'eq.inst.removeAsk': { en: 'Remove {codes}?', az: '{codes} silinsin?', ru: 'Удалить {codes}?' },
  'eq.inst.signedIn': { en: '{who} is signed in at {code}', az: '{who} {code} pəncərəsində işləyir', ru: '{who} работает за окном {code}' },
  'eq.inst.allDesks': { en: 'All counters', az: 'Bütün pəncərələr', ru: 'Все окна' },
  'eq.inst.desk': { en: 'Counter', az: 'Pəncərə', ru: 'Окно' },
  'eq.inst.deskFilter': { en: 'Counters shown', az: 'Göstərilən pəncərələr', ru: 'Показываемые окна' },
  'eq.inst.notInProfile': { en: 'Not in profile', az: 'Profildə yoxdur', ru: 'Нет в профиле' },
  'eq.inst.codeAsk': { en: 'Changing the code retires this one', az: 'Kod dəyişsə, bu cihaz istifadədən çıxır', ru: 'Смена кода выводит это устройство из работы' },
  'eq.inst.profileCount': { en: 'Profile: {n}', az: 'Profil: {n}', ru: 'Профиль: {n}' },
  'eq.inst.fewer': { en: 'Fewer', az: 'Azalt', ru: 'Уменьшить' },
  'eq.inst.more': { en: 'More', az: 'Artır', ru: 'Увеличить' },
  'eq.inst.notPublished': { en: 'Not published', az: 'Dərc olunmayıb', ru: 'Не опубликован' },
  'eq.inst.printerFault': { en: 'Printer fault', az: 'Printer xətası', ru: 'Ошибка принтера' },
  'eq.inst.noPrinter': { en: 'No printer', az: 'Printer yoxdur', ru: 'Нет принтера' },
  'eq.inst.skippedFilm': { en: 'Skipped a film', az: 'Video ötürüldü', ru: 'Пропущено видео' },
  'eq.inst.skippedPicture': { en: 'Skipped a picture', az: 'Şəkil ötürüldü', ru: 'Пропущена картинка' },
  'eq.inst.cache': { en: 'Cache {used} of {limit}', az: 'Keş: {used} / {limit}', ru: 'Кэш: {used} из {limit}' },

  // status
  'eq.problem.codeFormat': { en: '1 to 16 letters, digits, dash or underscore.', az: '1–16 hərf, rəqəm, tire və ya alt xətt.', ru: 'От 1 до 16 букв, цифр, дефисов или подчёркиваний.' },
  'eq.problem.codeTaken': { en: 'Another unit in this branch has this code.', az: 'Bu filialda başqa cihazın bu kodu var.', ru: 'Этот код уже у другого устройства отделения.' },
  'eq.problem.nameMissing': { en: 'It needs a name.', az: 'Ad lazımdır.', ru: 'Нужно название.' },
  'eq.problem.deskMissing': { en: 'Choose its counter.', az: 'Pəncərəsini seçin.', ru: 'Выберите окно.' },
  'eq.problem.deskUnknown': { en: 'There is no such counter in this branch.', az: 'Bu filialda belə pəncərə yoxdur.', ru: 'В отделении нет такого окна.' },
  'eq.problem.deskRepeated': { en: 'This counter is already chosen.', az: 'Bu pəncərə artıq seçilib.', ru: 'Это окно уже выбрано.' },

  // counter
  'eq.counter.finally': { en: 'Finally', az: 'Son qayda', ru: 'Иначе' },
  'eq.counter.rule': { en: 'Rule {n}', az: 'Qayda {n}', ru: 'Правило {n}' },
  'eq.counter.changedBy': { en: '{who} changed profile: {name}', az: '{who} profili dəyişdi: {name}', ru: '{who} сменил(а) профиль: {name}' },
  'eq.counter.changed': { en: 'Profile changed: {name}', az: 'Profil dəyişdi: {name}', ru: 'Профиль изменён: {name}' },
  'eq.counter.busy': { en: 'Finish the current customer first', az: 'Əvvəlcə cari müştərini bitirin', ru: 'Сначала завершите текущего клиента' },

  // floor
  'eq.floor.changed': { en: 'Profile changed at {desk}', az: '{desk}: profil dəyişdi', ru: '{desk}: профиль изменён' },

  // designs
  'eq.design.profile': { en: 'Operation profile', az: 'Əməliyyat profili', ru: 'Операционный профиль' },
  'eq.design.defaultFor': { en: 'Default for {profile}', az: '{profile} üçün standart', ru: 'По умолчанию для {profile}' },
  'eq.design.use': { en: 'Assign', az: 'İstifadə', ru: 'Использование' },
  'eq.design.useName': { en: 'Assign {name}', az: '«{name}» istifadəsi', ru: 'Использование «{name}»' },
  'eq.design.notInProfile': { en: 'Not in profile', az: 'Profilə uyğun deyil', ru: 'Не по профилю' },
  'eq.design.noProfiles': { en: 'No operation profiles', az: 'Əməliyyat profili yoxdur', ru: 'Нет операционных профилей' },
} satisfies Record<string, Phrase>
